/**
 * Course type names are displayed exactly as stored in the database, so lookups
 * return the stored record rather than the (possibly reformatted) input value.
 */

const collapseWhitespace = (value: string): string => value.replace(/\s+/g, ' ').trim();

export const findCourseTypeByName = (courseTypes: any[] | null | undefined, value: unknown): any => {
  if (!courseTypes?.length || typeof value !== 'string' || value.trim() === '') {
    return undefined;
  }

  const exactMatch = courseTypes.find((courseType) => courseType.courseType === value)
    || courseTypes.find((courseType) => courseType.courseType?.trim() === value.trim());
  if (exactMatch) {
    return exactMatch;
  }

  const collapsedValue = collapseWhitespace(value);
  return courseTypes.find((courseType) => (
    typeof courseType.courseType === 'string' && collapseWhitespace(courseType.courseType) === collapsedValue
  ));
};
